import * as tslib_1 from "tslib";
import { CalendarDateFormatter } from 'angular-calendar';
import { formatDate } from '@angular/common';
var CustomDateFormatter = /** @class */ (function (_super) {
    tslib_1.__extends(CustomDateFormatter, _super);
    function CustomDateFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomDateFormatter.prototype.monthViewColumnHeader = function (_a) {
        var date = _a.date, locale = _a.locale;
        return formatDate(date, 'EEE', locale);
    };
    // public monthViewTitle({ date, locale }: DateFormatterParams): string {
    //     return formatDate(date, 'MMM y', locale);
    // }
    CustomDateFormatter.prototype.weekViewColumnHeader = function (_a) {
        var date = _a.date, locale = _a.locale;
        return formatDate(date, 'EEE', locale);
    };
    return CustomDateFormatter;
}(CalendarDateFormatter));
export { CustomDateFormatter };
